import React, { useCallback, useContext, useMemo } from 'react'
import Modal from '../../../elem/Modal'
import toast from '../../../elem/Toast'

import { TableContext } from './TableContext'

const CommentsField = ({ setBulkComments, bulkComments }) => (
    <div className="field is-horizontal ">
        <div className="field-label is-align-items-center">
            <label className="label">Comments:</label>
        </div>
        <div className="field-body field control">
            <textarea
                rows="10"
                className="input is-fullwidth"
                value={bulkComments}
                onChange={e => {
                    setBulkComments(e.target.value)
                }}
            ></textarea>
        </div>
    </div>
)

const BulkSubmitButton = ({ action }) => {
    const {
        selectedUploads,
        bulkSubmit,
        setBulkComments,
        bulkComments,
        resolveBulkModalState,
        displayBulkApproveModal,
        displayBulkDenyModal,
        bulkSubmitLoading,
    } = useContext(TableContext)
    const allSelectedUploadsSubmitted = useMemo(
        () => selectedUploads.every(x => x.Status === 'Submitted'),
        [selectedUploads]
    )
    const allSelectedUploadsValid = useMemo(
        () => selectedUploads.every(x => x.IsValid === 'Pass'),
        [selectedUploads]
    )
    const isApprove = action === 'Approve'
    const isDeny = action === 'Deny'
    const isSubmit = action === 'Submit'

    const onApproveDenyClick = useCallback(() => {
        if (isApprove) {
            if (!allSelectedUploadsSubmitted || !allSelectedUploadsValid) {
                toast({
                    level: 'error',
                    message: `All selected forms must have a Validation Status of Pass in order to approve`,
                    alert: true,
                })
                return
            }
        } else if (isDeny) {
            if (!allSelectedUploadsSubmitted) {
                toast({
                    level: 'error',
                    message: `All selected forms must have Status of Submitted in order to deny`,
                    alert: true,
                })
                return
            }
        }
        resolveBulkModalState(action, true)
    }, [
        action,
        selectedUploads,
        isDeny,
        isApprove,
        isSubmit,
        allSelectedUploadsValid,
        allSelectedUploadsSubmitted,
    ])

    const onSubmitClick = useCallback(() => {
        if (!allSelectedUploadsValid) {
            toast({
                level: 'error',
                message: `All selected forms must have Validation Status of Pass in order to submit`,
                alert: true,
            })
            return
        }
        bulkSubmit(action)
    }, [
        action,
        selectedUploads,
        allSelectedUploadsValid,
        allSelectedUploadsSubmitted,
    ])

    return (
        <div style={{ display: 'flex', marginRight: '1rem' }}>
            <Modal
                display={
                    isApprove ? displayBulkApproveModal : displayBulkDenyModal
                }
                confirmAction={() => bulkSubmit(action)}
                confirmText={`${action} Forms`}
                denyAction={() => resolveBulkModalState(action, false)}
                denyText={`Cancel`}
                title={`${action} Forms`}
                pending={bulkSubmitLoading}
            >
                <CommentsField
                    setBulkComments={setBulkComments}
                    bulkComments={bulkComments}
                />
            </Modal>
            <button
                className={`button is-normal is-link bulkSubmitButton ${
                    bulkSubmitLoading ? `is-loading` : ``
                }`}
                disabled={selectedUploads.length === 0 || bulkSubmitLoading}
                onClick={() =>
                    isSubmit ? onSubmitClick() : onApproveDenyClick(action)
                }
            >
                {action}
            </button>
        </div>
    )
}

export default BulkSubmitButton
